import { CellValueType, Disposable, Inject } from '@univerjs/core';
import { INTERCEPTOR_POINT, SheetInterceptorService } from '@univerjs/sheets';

// Excel error literals only — so legitimate '#'-prefixed labels aren't zeroed.
const EXCEL_ERROR = /^#(NULL!|DIV\/0!|VALUE!|REF!|NAME\?|NUM!|N\/A|ERROR!|SPILL!|CALC!|GETTING_DATA)$/;

/** Formulas in the editor reference placeholder cells that hold no real value at
 *  design time — CWK col G VALUE cells point at missing RPK formulas, and RPK
 *  NUMBER cells render as their dropdown label ("No Default"), so arithmetic
 *  on them yields Excel error strings (#VALUE! / #REF! / #NAME? / #DIV/0!).
 *  Any cell resolving to such an error is rendered as 0 in both RPK and CWK.
 *  Underlying formula/value are untouched, so saved templates are unaffected. */
export class ErrorDisplayController extends Disposable {
  constructor(
    @Inject(SheetInterceptorService) private readonly _sheetInterceptorService: SheetInterceptorService,
  ) {
    super();

    this.disposeWithMe(
      this._sheetInterceptorService.intercept(INTERCEPTOR_POINT.CELL_CONTENT, {
        priority: 100,
        handler: (cell, _location, next) => {
          if (
            cell?.v != null
            && typeof cell.v === 'string'
            && EXCEL_ERROR.test(cell.v)
          ) {
            return next({ ...cell, v: 0, t: CellValueType.NUMBER });
          }
          return next(cell);
        },
      }),
    );
  }
}
